export default "__VITE_ASSET__DJQhgkeP__"